import React from 'react';

const ReviewList = ({ reviews }) => {
  if (!reviews || reviews.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500">
        <span className="material-symbols-outlined text-4xl mb-2 block">rate_review</span>
        <p>Ingen tilbakemeldinger ennå</p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('nb-NO', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="space-y-4">
      <h3 className="font-heading font-semibold text-[#0A1929] flex items-center gap-2">
        <span className="material-symbols-outlined text-[#1E3A5F]">reviews</span>
        Tilbakemeldinger ({reviews.length})
      </h3>

      <div className="space-y-3">
        {reviews.map((review) => (
          <div 
            key={review.id}
            className="bg-white rounded-xl p-4 shadow-sm border border-slate-100"
          >
            <div className="flex items-start gap-3">
              {/* Reviewer avatar */}
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#1E3A5F] to-[#0A1929] flex items-center justify-center flex-shrink-0">
                {review.reviewer?.profile_image ? (
                  <img 
                    src={review.reviewer.profile_image} 
                    alt={review.reviewer.name} 
                    className="w-full h-full object-cover rounded-full"
                  />
                ) : (
                  <span className="text-white font-bold text-sm">
                    {review.reviewer?.name?.charAt(0).toUpperCase() || '?'}
                  </span>
                )}
              </div>

              <div className="flex-grow">
                {/* Header */}
                <div className="flex items-center justify-between mb-1">
                  <span className="font-medium text-[#0A1929]">
                    {review.reviewer?.name || 'Anonym'}
                  </span>
                  <span className="text-xs text-slate-400">
                    {formatDate(review.created_at)}
                  </span>
                </div>

                {/* Rating */}
                <div className="flex items-center gap-1 mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span 
                      key={star}
                      className={`material-symbols-outlined text-sm ${
                        star <= review.rating ? 'text-yellow-500' : 'text-slate-300'
                      }`}
                    >
                      star
                    </span>
                  ))}
                </div>

                {/* Kommentar */}
                {review.comment && (
                  <p className="text-slate-600 text-sm">{review.comment}</p>
                )}

                {/* Oppdrag referanse */}
                {review.job_title && (
                  <div className="mt-2 text-xs text-slate-400 flex items-center gap-1">
                    <span className="material-symbols-outlined text-sm">work</span>
                    {review.job_title}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewList;
